(function () {
  'use strict';
  if (window.STMNChalkLive) return;
  var source = document.getElementById('stmn-chalk-live-config');
  if (!source) return;
  var config = JSON.parse(source.textContent), busy = false, latestRead = 0;
  var percent = (window.STMNBtb?.config.chalkActive || Date.now() >= Date.parse('2026-09-10T08:30:00+02:00')) ? 40 : 30;
  var root = config.root.replace(/\/?$/, '/');
  function money(cents) { return new Intl.NumberFormat(config.locale, {style:'currency', currency:config.currency}).format(cents / 100); }
  function node(tag, className, text) { var el = document.createElement(tag); if (className) el.className = className; if (text) el.textContent = text; return el; }
  function read(response) { return response.json().then(function (data) { if (!response.ok) throw new Error(data.description || data.message || 'Non è stato possibile aggiornare il carrello.'); return data; }); }
  // BACK15 is an order discount: Shopify can prefer it to the second-pair offer.
  // Suspend only this retarget code while the qualifying pair is in the ordinary-theme cart.
  var reconciliation = null, suspendedKey = 'stmn_chalk_back15_suspended';
  var suspended = false, checkoutReplay = new WeakSet();
  try { suspended = sessionStorage.getItem(suspendedKey) === '1'; } catch (e) {}
  function rememberSuspended(value) {
    suspended = value;
    try { if (value) sessionStorage.setItem(suspendedKey, '1'); else sessionStorage.removeItem(suspendedKey); } catch (e) {}
  }
  function livePair(cart) {
    if (window.STMNBtb?.active) return false;
    var items = cart.items || [];
    return items.some(function (item) { return item.quantity > 0 && config.triggers.includes(item.handle); }) &&
      items.some(function (item) { return item.quantity > 0 && config.targets.includes(item.handle); });
  }
  function publishCart(cart) {
    window.STMNChalkLive.pairActive = livePair(cart);
    document.dispatchEvent(new CustomEvent('stmn:chalk-promo-state', {detail:{pairActive:livePair(cart),cart:cart}}));
  }
  function showPromoMessage(message, error) {
    var parent = document.querySelector('.cart-layout__items');
    var el = parent ? document.getElementById('stmn-chalk-promo-message') : document.getElementById('mp-cart-discount-msg');
    if (!el && parent) {
      if (!el) { el = node('p', 'stmn-chalk-live__terms'); el.id = 'stmn-chalk-promo-message'; el.setAttribute('role', 'status'); parent.appendChild(el); }
    }
    if (!el) return;
    el.textContent = message;
    el.style.color = error ? '#b91c1c' : '#166534';
  }
  function redrawCart() {
    if (document.querySelector('.cart-layout__items')) { location.reload(); return; }
    if (typeof window.mpCartDrawerRefresh === 'function') window.mpCartDrawerRefresh();
  }
  function reconcile(cart) {
    if (reconciliation) return reconciliation;
    reconciliation = Promise.resolve(cart || fetch(root + 'cart.js').then(read)).then(function (current) {
      var pair = livePair(current);
      var codes = (current.discount_codes || []).map(function (code) { return String(code.code || '').trim(); }).filter(Boolean);
      var hasBack15 = codes.some(function (code) { return code.toUpperCase() === 'BACK15'; });
      publishCart(current);
      if (pair && suspended && !hasBack15) showPromoMessage('Attiva l’offerta −'+percent+'% sul secondo SYNTH o ROCKET. BACK15 sospeso. Promo non cumulabile con altri codici sconto.');
      if (pair && hasBack15) {
        return fetch(root + 'cart/update.js', {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({discount:codes.filter(function (code) { return code.toUpperCase() !== 'BACK15'; }).join(',')})})
          .then(read).then(function (updated) {
            if ((updated.discount_codes || []).some(function (code) { return String(code.code || '').toUpperCase() === 'BACK15'; })) throw new Error('Non è stato possibile attivare l’offerta sul secondo paio. Riprova prima di procedere.');
            rememberSuspended(true);
            publishCart(updated);
            showPromoMessage('Attiva l’offerta −'+percent+'% sul secondo SYNTH o ROCKET. BACK15 sospeso. Promo non cumulabile con altri codici sconto.');
            return {cart:updated,changed:true};
          });
      }
      if (!pair && suspended && !window.STMNBtb?.active) {
        if (codes.length) { rememberSuspended(false); return {cart:current,changed:false}; }
        if ((current.items || []).length) {
          return fetch(root + 'cart/update.js', {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({discount:'BACK15'})}).then(read).then(function (updated) {
            rememberSuspended(false);
            publishCart(updated);
            showPromoMessage('Offerta secondo paio rimossa. BACK15 ripristinato sugli articoli idonei.');
            return {cart:updated,changed:true};
          });
        }
      }
      return {cart:current,changed:false};
    }).finally(function () { reconciliation = null; });
    return reconciliation;
  }
  function guardCheckout(event, target, resume) {
    if (checkoutReplay.has(target)) return;
    if (window.STMNBtb?.active || (!reconciliation && !busy && !window.STMNChalkLive.pairActive)) return;
    event.preventDefault(); event.stopImmediatePropagation();
    if (target.dataset.stmnChalkChecking === '1') return;
    target.dataset.stmnChalkChecking = '1';
    reconcile().then(function (result) {
      if (result.changed) { redrawCart(); return; }
      checkoutReplay.add(target);
      try { resume(); } finally { checkoutReplay.delete(target); }
    }).catch(function (error) { showPromoMessage(error.message, true); })
      .finally(function () { delete target.dataset.stmnChalkChecking; });
  }
  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('a[href]');
    if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    var url = new URL(link.href, location.href);
    if (url.origin !== location.origin || !/\/checkout\/?$/.test(url.pathname)) return;
    guardCheckout(event, link, function () { link.click(); });
  }, true);
  document.addEventListener('submit', function (event) {
    var form = event.target, submitter = event.submitter;
    if (!submitter || submitter.name !== 'checkout') return;
    var url = new URL(form.action, location.href);
    if (url.origin !== location.origin || !/\/cart\/?$/.test(url.pathname)) return;
    guardCheckout(event, form, function () { form.requestSubmit(submitter); });
  }, true);

  function price(el, cents) {
    el.replaceChildren(node('del', '', money(cents)), node('strong', '', money(cents - Math.floor(cents * percent / 100))), node('span', 'stmn-chalk-live__badge', '−'+percent+'%'));
  }
  function build(where) {
    var box = node('section', 'stmn-chalk-live'); box.dataset.stmnChalkLive = where;
    box.setAttribute('aria-label', 'Offerta secondo paracalli Chalk');
    box.appendChild(node('h3', '', 'Aggiungi SYNTH o ROCKET al −'+percent+'%'));
    var chooser = node('div', 'stmn-chalk-live__chooser'); chooser.setAttribute('role', 'group'); chooser.setAttribute('aria-label', 'Scegli il secondo paracalli Chalk'); box.appendChild(chooser);
    var firstProduct = true;
    config.products.forEach(function (product) {
      var variants = product.variants.filter(function (v) { return v.available; }); if (!variants.length) return;
      var row = node('div', 'stmn-chalk-live__row'), img = node('img', 'stmn-chalk-live__image');
      var choice = node('button', 'stmn-chalk-live__choice', product.handle === 'paracalli-synth-free' ? 'SYNTH' : 'ROCKET'); choice.type = 'button'; choice.setAttribute('aria-pressed', String(firstProduct)); row.hidden = !firstProduct; firstProduct = false;
      choice.addEventListener('click', function () { if (busy) return; box.querySelectorAll('.stmn-chalk-live__row').forEach(function (other) { other.hidden = other !== row; }); chooser.querySelectorAll('button').forEach(function (other) { other.setAttribute('aria-pressed', String(other === choice)); }); }); chooser.appendChild(choice);
      img.src = product.image; img.alt = product.title; img.width = 56; img.height = 66; img.loading = 'lazy'; row.appendChild(img);
      var info = node('div', 'stmn-chalk-live__info'), name = node('a', 'stmn-chalk-live__name', product.title);
      name.href = root + 'products/' + product.handle; info.appendChild(name);
      var amount = node('div', 'stmn-chalk-live__price'); price(amount, variants[0].price); info.appendChild(amount);
      var select = node('select', 'stmn-chalk-live__size'); select.setAttribute('aria-label', 'Taglia ' + product.title);
      var placeholder = node('option', '', 'Scegli la taglia'); placeholder.value = ''; placeholder.disabled = true; placeholder.selected = true; select.appendChild(placeholder);
      variants.forEach(function (v) { var option = node('option', '', v.title === 'Default Title' ? 'Taglia unica' : v.title); option.value = v.id; select.appendChild(option); });
      row.appendChild(info);
      var actions = node('div', 'stmn-chalk-live__actions'); actions.appendChild(select);
      var button = node('button', 'stmn-chalk-live__button', 'Aggiungi'); button.type = 'button'; button.disabled = true; button.setAttribute('aria-label', 'Aggiungi ' + product.title + ' al '+percent+'% di sconto');
      select.addEventListener('change', function () { var v = variants.find(function (v) { return String(v.id) === select.value; }); if (!v) return; price(amount, v.price); button.disabled = busy; });
      button.addEventListener('click', function () {
        if (busy || !select.value) return; busy = true;
        document.querySelectorAll('[data-stmn-chalk-live] button,[data-stmn-chalk-live] select').forEach(function (el) { el.disabled = true; });
        button.textContent = 'Aggiunta…'; error.hidden = true;
        fetch(root + 'cart/add.js', {method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({items:[{id:Number(select.value),quantity:1}]})})
          .then(read).then(function () { return window.STMNBtb?.active ? window.STMNBtb.ensureDiscount() : reconcile(); }).then(function () {
            document.dispatchEvent(new CustomEvent('stmn:cart-changed'));
            if (where === 'page') { location.reload(); return; }
            if (typeof window.mpCartDrawerRefresh === 'function') window.mpCartDrawerRefresh();
          }).catch(function (e) { error.textContent = e.message; error.hidden = false; })
          .finally(function () {
            busy = false; button.textContent = 'Aggiungi';
            document.querySelectorAll('[data-stmn-chalk-live] select,.stmn-chalk-live__choice').forEach(function (el) { el.disabled = false; });
            document.querySelectorAll('.stmn-chalk-live__row').forEach(function (el) { el.querySelector('button').disabled = !el.querySelector('select').value; });
          });
      }); actions.appendChild(button); row.appendChild(actions); box.appendChild(row);
    });
    box.appendChild(node('p', 'stmn-chalk-live__terms', percent === 40 ? 'Con HYBRID, ZERO o ZERO Slim: −40% complessivo su 1 secondo SYNTH o ROCKET. '+(window.STMNBtb?.active ? 'Il NO CHALK resta al −25%; sul secondo paio il −40% sostituisce il −25%. ' : 'Il NO CHALK resta a prezzo pieno. ')+'Massimo 1 secondo paio per ordine. Non cumulabile con altri codici.' : '−30% su 1 secondo SYNTH o ROCKET con HYBRID, ZERO o ZERO Slim a prezzo pieno. Massimo 1 per ordine. Non cumulabile con altre promo.'));
    var error = node('p', 'stmn-chalk-live__error'); error.setAttribute('role', 'alert'); error.hidden = true; box.appendChild(error);
    return box;
  }
  function render(cart) {
    var items = cart.items || [];
    var eligible = items.some(function (i) { return config.triggers.includes(i.handle); }) && !items.some(function (i) { return config.targets.includes(i.handle); });
    if (!eligible) { document.querySelectorAll('[data-stmn-chalk-live]').forEach(function (el) { el.remove(); }); return; }
    [{where:'drawer',el:document.getElementById('mp-cart-items')},{where:'page',el:document.querySelector('.cart-layout__items')}].forEach(function (target) {
      if (target.el && !target.el.querySelector('[data-stmn-chalk-live]')) target.el.appendChild(build(target.where));
    });
  }
  function refresh() {
    var request = ++latestRead;
    return reconcile().then(function (result) {
      if (request === latestRead) render(result.cart);
      if (result.changed) redrawCart();
      return result.cart;
    }).catch(function (error) { showPromoMessage(error.message, true); });
  }
  document.addEventListener('stmn:cart-rendered', function (event) {
    var request = ++latestRead;
    reconcile(event.detail).then(function (result) {
      if (request === latestRead) render(result.cart);
      if (result.changed) redrawCart();
    }).catch(function (error) { showPromoMessage(error.message, true); });
  });
  document.addEventListener('stmn:cart-changed', refresh);
  window.STMNChalkLive = {refresh:refresh, reconcile:reconcile, pairActive:false};
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh, {once:true}); else refresh();
})();
